/* import __COLOCATED_TEMPLATE__ from './head-tag.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();